<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.357143"
      y="0.357143"
      width="39.2857"
      height="39.2857"
      rx="8.21429"
      fill="#E7EAEE"
    />
    <rect
      x="0.357143"
      y="0.357143"
      width="39.2857"
      height="39.2857"
      rx="8.21429"
      stroke="#E7EAEE"
      stroke-width="0.714286"
    />
    <path d="M27.1571 23.4431L24.9214 18.2145C24.5142 17.2574 23.9071 16.7145 23.2142 16.6788C22.5285 16.6431 21.8642 17.1217 21.3571 18.0359L20 20.4717C19.7142 20.9859 19.3071 21.2931 18.8642 21.3288C18.4142 21.3717 17.9642 21.1359 17.6 20.6717L17.4428 20.4717C16.9357 19.8359 16.3071 19.5288 15.6642 19.5931C15.0214 19.6574 14.4714 20.1002 14.1071 20.8217L12.8714 23.2859C12.4285 24.1788 12.4714 25.2145 12.9928 26.0574C13.5142 26.9002 14.4214 27.4074 15.4142 27.4074H24.5285C25.4857 27.4074 26.3785 26.9288 26.9071 26.1288C27.45 25.3288 27.5357 24.3217 27.1571 23.4431Z" fill="#0D0626" />
    <path d="M16.4071 17.4145C17.7405 17.4145 18.8214 16.3336 18.8214 15.0002C18.8214 13.6669 17.7405 12.5859 16.4071 12.5859C15.0737 12.5859 13.9928 13.6669 13.9928 15.0002C13.9928 16.3336 15.0737 17.4145 16.4071 17.4145Z" fill="#0D0626" />
  </svg>
</template>
